export const TRANSLATION_SCOPE = 'themeModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
